module.exports = __webpack_public_path__ + "img/checkmark1.0cb25723.svg";